import { useNavigate, useSearchParams } from 'react-router-dom';
import { useFirmContext } from '../../providers/FirmProvider';
import { Controller, useFormContext } from 'react-hook-form';
import { Badge, Button } from '@cimplico/components';
import { ChevronLeftIcon } from '@heroicons/react/24/solid';
import FYIJobSelect from '../../components/fyi-job-select/FYIJobSelect';

type NewWorkpaperStepFourProps = {
    onPrev: () => void;
    onSubmit: () => void;
    isSubmitting: boolean;
};

function NewWorkpaperStepFour({ onPrev, onSubmit, isSubmitting }: NewWorkpaperStepFourProps): JSX.Element {
    const navigate = useNavigate();
    const { shortId } = useFirmContext();
    const { watch, handleSubmit, trigger, formState, control } = useFormContext();
    const entity = watch('entity');

    const [params] = useSearchParams();
    const returnTo = params.get('returnTo');

    function handleCancel(): void {
        navigate(returnTo || `/${shortId}/workpapers`);
    }

    return (
        <fieldset disabled={isSubmitting}>
            <form className="flex flex-row" onSubmit={handleSubmit(onSubmit)}>
                <div className="mr-4">
                    <Button leftIcon={<ChevronLeftIcon />} onClick={(): void => onPrev()} size="md" type="hollow" disabled={isSubmitting} />
                </div>
                <div className="flex flex-col gap-8 w-full">
                    <p className="text-2xl">{entity.name}</p>
                    <div className="flex flex-col w-full">
                        <div className="w-fit mb-1">
                            <Badge size="small" shape="squared" color="indigo" label="Beta" />
                        </div>
                        <Controller
                            name="fyiJob"
                            control={control}
                            render={({ field: { onChange, value } }): JSX.Element => (
                                <FYIJobSelect
                                    isOptional
                                    onChange={(job): void => {
                                        onChange(job);
                                        trigger();
                                    }}
                                    selectedJob={value ? { name: value.name, id: value.id } : undefined}
                                    title="FYI Job"
                                    placeholder="Select a job..."
                                    fyiEntityId={entity.integrations.fyi.id}
                                    hint="* Any documents filed to this job against your configured cabinet will automatically be added to the workpaper. Please ensure the correct job is selected."
                                />
                            )}
                        />
                    </div>
                    {/* FORM CANCEL + NEXT STEP */}
                    <div className="flex justify-end gap-4">
                        <Button type="hollow" label="Cancel" onClick={handleCancel} disabled={isSubmitting} />
                        <Button
                            type="primary"
                            isSubmit
                            label={isSubmitting ? 'Creating...' : 'Create Workpaper'}
                            disabled={isSubmitting}
                            isLoading={isSubmitting}
                        />
                    </div>
                </div>
            </form>
        </fieldset>
    );
}

export default NewWorkpaperStepFour;
